const authorsPath = '/authors';
export default authorsPath;
